import type { EditorPlugin } from '../../../types/aha-editor';
import CodeSnippetComponentPlugin from './CodeSnippetComponentPlugin';
import CodeSnippetMarkdownPlugin from './CodeSnippetMarkdownPlugin';
import CodeSnippetSchemaPlugin from './CodeSnippetSchemaPlugin';

const CodeSnippetPlugin: EditorPlugin[] = [
  CodeSnippetSchemaPlugin,
  CodeSnippetMarkdownPlugin,
  CodeSnippetComponentPlugin,
];
export default CodeSnippetPlugin;
